import { useEffect, useMemo, useState } from 'react';
import useAuth from 'src/hooks/useAuth';
import SharedPerguntasEssenciaisSection from '../_shared/PerguntasEssenciaisSection';
import { CATALOGO, LIMITE_ATIVAS, LIMITE_QUALIF } from './perguntas/catalog';
import { CATEGORIAS_FALLBACK, buildInitialWorkflow } from './perguntas/categorias';
import { v2_actionListarCategorias } from 'src/actions/v2/cadastro/v2_actionProdutos';

/**
 * Wrapper do vertical de varejo sobre o motor de coleta compartilhado.
 *
 * Diferença deliberada em relação ao imobiliário: os itens que o lojista pode
 * adicionar ao fluxo são as CATEGORIAS REAIS dele (cadastro de produtos), não
 * uma lista estática. Categorias já são um cadastro do tenant, então pedir que
 * ele escolha de uma lista genérica seria pior.
 *
 * `CATEGORIAS_FALLBACK` cobre os dois casos em que a API não ajuda: falha na
 * chamada, ou cliente que ainda não cadastrou categoria nenhuma. Sem isso o
 * seletor ficaria vazio e o canvas, inutilizável.
 */
export default function PerguntasEssenciaisSection({ aiAgent, changeModuleConfig }) {
    const { cliente } = useAuth();
    const [categorias, setCategorias] = useState(null);

    useEffect(() => {
        let cancelado = false;
        async function carregar() {
            if (!cliente?._id) return;
            try {
                const resp = await v2_actionListarCategorias(cliente._id);
                if (cancelado) return;
                const lista = Array.isArray(resp?.data?.data) ? resp.data.data : [];
                setCategorias(lista.map((c) => ({
                    id: String(c._id),
                    label: c.name,
                    icon: 'mdi:shape-outline',
                })));
            } catch (err) {
                if (!cancelado) setCategorias([]);
            }
        }
        carregar();
        return () => { cancelado = true; };
    }, [cliente?._id]);

    const itensAdicionaveis = useMemo(
        () => (categorias && categorias.length > 0 ? categorias : CATEGORIAS_FALLBACK),
        [categorias]
    );

    return (
        <SharedPerguntasEssenciaisSection
            aiAgent={aiAgent}
            changeModuleConfig={changeModuleConfig}
            moduleKey="ecommerce"
            catalogo={CATALOGO}
            itensAdicionaveis={itensAdicionaveis}
            buildInitialWorkflow={buildInitialWorkflow}
            limiteAtivas={LIMITE_ATIVAS}
            limiteQualif={LIMITE_QUALIF}
            i18nBase="aiAgents.ecommerce.perguntasEssenciais."
            i18nPerguntas="aiAgents.ecommerce.perguntas."
        />
    );
}
